module.exports = __webpack_public_path__ + "img/一键生成报告弹窗.7b0c97d3.png";